<template>
  <div :class="[ baseClass, padding, { 'items-center' : center }]">
    <v-date-picker v-if="date" ref="calendar" class="hidden" :value="null" :locale="$i18n.locale" />
    <dt :class="[ termClass, termCol ]">
      <slot name="term">
        {{ date && dateFormat ? `${term} (${dateFormat})` : term }}
      </slot>
    </dt>
    <dd :class="[ definitionClass, definitionCol, { 'text-right' : alignRight } ]">
      <slot />
    </dd>
  </div>
</template>

<script>
export default {
  name: 'ODescriptionDetails',
  props: {
    term: {
      type: String,
      default: null,
    },
    baseClass: {
      type: String,
      default: 'sm:grid sm:grid-cols-6 sm:gap-1',
    },
    termClass: {
      type: String,
      default: 'text-sm leading-5 opacity-80',
    },
    definitionClass: {
      type: String,
      default: 'mt-1 text-sm leading-5 sm:mt-0',
    },
    termCol: {
      type: String,
      default: 'sm:col-span-1',
    },
    definitionCol: {
      type: String,
      default: 'sm:col-span-5',
    },
    center: {
      type: Boolean,
      default: false,
    },
    alignRight: {
      type: Boolean,
      default: false,
    },
    padding: {
      type: String,
      default: 'py-3',
    },
    date: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      dateFormat: '',
    }
  },
  mounted () {
    if (this.date) {
      this.dateFormat = this.$refs.calendar?.$locale.masks.L
    }
  },
}
</script>
